import type { Category } from '@sse/schema';

/** Nome singolare e plurale, e variabile colore, per ogni categoria (it.json del sito v1). */
export const CATEGORY_LABELS: Record<Category, { singular: string; plural: string }> = {
  EVENTI: { singular: 'Evento', plural: 'Eventi' },
  FESTE_PATRONALI: { singular: 'Festa patronale', plural: 'Feste patronali' },
  SAGRE: { singular: 'Sagra', plural: 'Sagre' },
  CONCERTI: { singular: 'Concerto', plural: 'Concerti' },
  TEATRI: { singular: 'Teatro', plural: 'Teatri' },
  MOSTRE: { singular: 'Mostra', plural: 'Mostre' },
  CINEMA: { singular: 'Cinema', plural: 'Cinema' },
  FESTIVAL_CULTURALI: { singular: 'Festival culturale', plural: 'Festival culturali' },
  EVENTI_DI_DANZA: { singular: 'Evento di danza', plural: 'Eventi di danza' },
  EVENTI_LETTERARI: { singular: 'Evento letterario', plural: 'Eventi letterari' },
  MERCATINI: { singular: 'Mercatino', plural: 'Mercatini' },
  FIERE: { singular: 'Fiera', plural: 'Fiere' },
  CIBO_VINO: { singular: 'Cibo e vino', plural: 'Cibo e vino' },
  EVENTI_NATALIZI: { singular: 'Evento natalizio', plural: 'Eventi natalizi' },
  CARNEVALE: { singular: 'Carnevale', plural: 'Carnevale' },
};

export const categoryColorVar = (c: Category) =>
  `var(--color-cat-${c.toLowerCase().replaceAll('_', '-')})`;
